<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex sx12>
          <h1 class="mt-n2 mb-4">System</h1>
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
          <div v-else raised>
            <v-textarea
              rows="14"
              label="Log"
              v-model="form.log"
            >
            </v-textarea>
            <v-btn :loading="loading" @click="loadLog" color="primary">Load log</v-btn>
            <v-textarea
              label="Test result"
              v-model="form.testResult"
            >
            </v-textarea>
            <v-btn :loading="loading" @click="loadTest" color="primary">Test</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import * as Sys from '@/core/system'

export default {
  data: () => ({
    loading: true,
    form: {
      log: '',
      testResult: ''
    }
  }),
  computed: {
  },
  methods: {
    async loadLog () {
      this.loading = true
      const res = await Sys.getLog()
      if (!res.failed) {
        this.$root.$message.showSuccess('Log loaded')
        this.form.log = res.data
      }
      this.loading = false
    },
    async loadTest () {
      this.loading = true
      const res = await Sys.getTest(
        {
          Date: new Date().toJSON(),
          TimeZoneId: 'Romance Standard Time',
          Data1: this.form.testResult
        }
      )
      if (!res.failed) {
        this.$root.$message.showSuccess('Test loaded')
        this.form.testResult = res.data
      }
      this.loading = false
    }
  },
  async mounted () {
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    this.$nextTick(() => {
      this.loading = false
    })
  }
}
</script>

<style scoped>
</style>
